import script from "./BenefitingBeplanet.vue?vue&type=script&setup=true&lang=js"
export * from "./BenefitingBeplanet.vue?vue&type=script&setup=true&lang=js"

import "./BenefitingBeplanet.vue?vue&type=style&index=0&id=5086822c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5086822c"]])

export default __exports__